import SpecialEventFrequency from './SpecialEventFrequency'
import SpecialEventType from './SpecialEventType'
import Month from './Month'
import OrderMethod from './OrderMethod'
import CallFrequency from './CallFrequency'
import MerchLevel from './MerchLevel'
import MerchPercentage from './MerchPercentage'
import DistributionMode from './DistributionMode'
import PalletType from './PalletType'
import TimeProfile from './TimeProfile'
import DelayBetweenOrderAndDelivery from './DelayBetweenOrderAndDelivery'
import MasterDeliveryRoute from './MasterDeliveryRoute'
import SalesOffice from './SalesOffice'
import Employee from './Employee'
import { DateUtil }         from '../util/DateUtil';
export class SalesAndDeliveryInfo {
    RequestID: number;
    SpecialEventCustomer: boolean;
    SpecialEventFrequencyID?: number;
    SpecialEventFrequency?: SpecialEventFrequency;
    SeasonalOrderer: boolean;
    SeasonalStartMonthID?: number;
    SeasonalStartMonth?: Month;
    SeasonalEndMonthID?: number;
    SeasonalEndMonth?: Month;
    SalesRoute: string;
    ServiceArea: string;
    DelayBetweenOrderAndDeliveryID?: number;
    DelayBetweenOrderAndDelivery?: DelayBetweenOrderAndDelivery;
    GoodsReceivingHours: string;
    GoodsReceivingHoursStart: Date;
    GoodsReceivingHoursEnd: Date;
    GoodsReceivingHoursStartString: string;
    GoodsReceivingHoursEndString: string;
    OrderMethodID?: number;
    OrderMethod?: OrderMethod;
    FirstCallDate?: Date;
    CallFrequencyID?: number;
    CallFrequency?: CallFrequency;
    MerchLevelID?: number;
    MerchLevel?: MerchLevel;
    MerchPercentageID?: number;
    MerchPercentage?: MerchPercentage;
    DistributionModeID?: number;
    DistributionMode?: DistributionMode;
    PalletTypeID?: number;
    PalletType?: PalletType;
    TimeProfileID?: number;
    TimeProfile?: TimeProfile;        
    FirstDeliveryDate?: Date;
    DifferentDeliveryPoints?: boolean;
    CrossDockSalesOfficeID?: number;
    CrossDockSalesOffice?: SalesOffice;
    MasterRoute?: string;
    MasterRouteSequence?: string;
    ZRPartnerEmployeeID?: number; //Sales Rep
    ZJPartnerEmployeeID?: number;
    ZNPartnerEmployeeID?: number; //Account Developer
    ZKPartnerEmployeeID?: number; //Account Developer
    ZRPartnerEmployee?: Employee;
    ZJPartnerEmployee?: Employee; //Key Account Manager
    ZNPartnerEmployee?: Employee;
    ZKPartnerEmployee?: Employee;
    FaceToFaceVisitPlan?: boolean;
    SpecialEventTypeID?: number;
    SpecialEventType?: SpecialEventType;
    MasterDeliveryRouteID?: number;
    MasterDeliveryRoute?: MasterDeliveryRoute;
    DeleteZJPartner?: boolean;
    DeleteZNPartner?: boolean;
}

export default SalesAndDeliveryInfo;